import { useMemo } from 'react';

interface UsePaginationProps {
  currentPageIndex: number;
  totalPages: number;
}

export const usePagination = ({ currentPageIndex, totalPages }: UsePaginationProps) => {
  const paginationGroup = useMemo(() => {
    // If 7 or fewer pages, show all page numbers
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }

    const pagesToShow = new Set<number>();
    pagesToShow.add(0); // Always show the first page

    // Show pages around the current page
    for (let i = -1; i <= 1; i++) {
      const page = currentPageIndex + i;
      if (page > 0 && page < totalPages - 1) {
        pagesToShow.add(page);
      }
    }

     // Ensure the current page is added, especially if it's near the start or end
    if(currentPageIndex > 0 && currentPageIndex < totalPages - 1) {
      pagesToShow.add(currentPageIndex);
    }

    pagesToShow.add(totalPages - 1); // Always show the last page

    const sortedPages = Array.from(pagesToShow).sort((a, b) => a - b);
    const finalPages: (number | string)[] = [];

    let lastPage: number | null = null;
    for (const page of sortedPages) {
      if (lastPage !== null && page - lastPage > 1) {
        finalPages.push('...'); // Add ellipsis if there's a gap
      }
      finalPages.push(page);
      lastPage = page;
    }
    return finalPages;
  }, [currentPageIndex, totalPages]);

  return paginationGroup;
};
